// extracted by mini-css-extract-plugin
export default {"bottomPadding":"GalleryBrandedPage_bottomPadding__8g04x"};